import React from "react";

function BS4_GridXLarge() {
  return (
    <div>
      <h1>BS4_GridXLarge Component</h1>
      <p>This is the BS4_GridXLarge tutorial page content.</p>
    </div>
  );
}

export default BS4_GridXLarge;
